const powerSources = [
  { icon: 'ri-vip-crown-line', title: 'Формальная власть', desc: 'Полномочия, которые даёт должность. Позволяет отдать приказ, но не гарантирует качественное исполнение и ответственность.' },
  { icon: 'ri-lightbulb-line', title: 'Экспертное влияние', desc: 'Влияние, основанное на знаниях и опыте. Сотрудники охотнее следуют за тем, кто разбирается в вопросе.' },
  { icon: 'ri-user-star-line', title: 'Личный авторитет', desc: 'Доверие, которое руководитель зарабатывает последовательностью, справедливостью и выполнением собственных обещаний.' },
  { icon: 'ri-heart-3-line', title: 'Доверие', desc: 'Уверенность сотрудника в том, что руководитель действует в интересах дела и не подведёт.' },
  { icon: 'ri-scales-2-line', title: 'Аргументация', desc: 'Способность объяснить необходимость решения через факты, цели бизнеса и интересы сторон.' },
  { icon: 'ri-file-check-line', title: 'Система договорённостей', desc: 'Понятные правила, зафиксированные обязательства и контроль, которые делают результат устойчивым.' },
];

export default function PowerAndNegotiation() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему должность не всегда помогает договориться
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          У руководителя есть несколько источников влияния, и должность — лишь один из них
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {powerSources.map((p) => (
            <div key={p.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${p.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{p.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto">
          <p className="text-base text-teal-800 leading-relaxed">
            Руководитель может заставить сотрудника выполнить действие один раз. Но устойчивый результат возникает тогда, когда сотрудник понимает задачу, принимает ответственность и знает последствия невыполнения договорённостей.
          </p>
        </div>
      </div>
    </section>
  );
}